export default __webpack_public_path__ + "static/media/dresden1.d7aeec0e.png";